export default __webpack_public_path__ + "static/media/mic-off.401357b7.svg";